import { Injectable } from '@angular/core';
import {
  MyHttpClientFactory,
  ResponseCasingEnum,
  LocalStorageService,
  environment,
} from '@ups/xplat/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ParentCustomerDto, ProfileModel } from '@ups/xplat/api/dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchCustomerService {
  private http: HttpClient;
  private profile: ProfileModel;

  constructor(
    private clientFactory: MyHttpClientFactory,
    private storage: LocalStorageService
  ) {
    this.http = this.clientFactory.createHttpClient(
      environment.urls.spartaAPI,
      true,
      ResponseCasingEnum.PascalCase
    );
    this.profile = this.storage.getItem('profile') as ProfileModel;
  }

  search(
    searchString: string,
    params: HttpParams = null,
    limit: number = 50
  ): Observable<ParentCustomerDto[]> {
    params = params || new HttpParams();
    params = params.append('searchString', searchString);
    params = params.append('take', limit);
    return this.http.get<ParentCustomerDto[]>(`/api/parentCustomers`, {
      params,
    });
  }

  /* eslint-disable */
  public addOrRemoveFavoriteCustomer(customerID: string | number) {
    const url = `/api/parentCustomers/favorite`;
    this.http
      .post(url, {
        UserID: this.profile.auth0UserId,
        ParentCustomerID: customerID,
      })
      .toPromise();
  }
  /* eslint-enable */
}
